import { render, staticRenderFns } from "./g_cellsafe.vue?vue&type=template&id=2dc4aff5&"
import script from "./g_cellsafe.vue?vue&type=script&lang=js&"
export * from "./g_cellsafe.vue?vue&type=script&lang=js&"
import style0 from "./g_cellsafe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports